import React, { useState } from 'react';

const MOCK = [
  { id:1, name:'John Rivera', email:'john@example.com', phone:'(404) 555-0101', type:'Client', policies:2, status:'Active' },
  { id:2, name:'Sarah Chen', email:'sarah@example.com', phone:'(404) 555-0102', type:'Prospect', policies:0, status:'Lead' },
  { id:3, name:'Marcus Williams', email:'marcus@example.com', phone:'(404) 555-0103', type:'Client', policies:3, status:'Active' },
  { id:4, name:'Lisa Thompson', email:'lisa@example.com', phone:'(770) 555-0104', type:'Prospect', policies:0, status:'Nurture' },
  { id:5, name:'David Park', email:'david@example.com', phone:'(678) 555-0105', type:'Client', policies:1, status:'Active' },
  { id:6, name:'Jennifer Adams', email:'jen@example.com', phone:'(404) 555-0106', type:'Client', policies:4, status:'Active' },
];

const ContactManagement: React.FC = () => {
  const [contacts, setContacts] = useState(MOCK);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('All');
  const [showModal, setShowModal] = useState(false);
  const [newContact, setNewContact] = useState({ name:'', email:'', phone:'', type:'Prospect' });

  const filtered = contacts.filter(c =>
    (filter === 'All' || c.type === filter) &&
    (c.name.toLowerCase().includes(search.toLowerCase()) || c.email.toLowerCase().includes(search.toLowerCase()))
  );

  const addContact = () => {
    if (!newContact.name) return;
    setContacts(p => [...p, { ...newContact, id: Date.now(), policies: 0, status: 'Lead' }]);
    setNewContact({ name:'', email:'', phone:'', type:'Prospect' });
    setShowModal(false);
  };

  const statusColor: Record<string,string> = { Active:'bg-green-100 text-green-700', Lead:'bg-blue-100 text-blue-700', Nurture:'bg-yellow-100 text-yellow-700' };

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <h1 className="text-2xl font-bold text-gray-900">Contacts ({filtered.length})</h1>
        <button onClick={() => setShowModal(true)} className="px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700">+ New Contact</button>
      </div>
      <div className="flex flex-col sm:flex-row gap-3">
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search contacts..."
          className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
        <select value={filter} onChange={e => setFilter(e.target.value)} className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none">
          {['All','Client','Prospect'].map(t => <option key={t}>{t}</option>)}
        </select>
      </div>
      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr>{['Name','Email','Phone','Type','Policies','Status',''].map(h => <th key={h} className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">{h}</th>)}</tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {filtered.map(c => (
              <tr key={c.id} className="hover:bg-gray-50">
                <td className="px-4 py-3 font-medium text-gray-900">{c.name}</td>
                <td className="px-4 py-3 text-gray-600">{c.email}</td>
                <td className="px-4 py-3 text-gray-600">{c.phone}</td>
                <td className="px-4 py-3 text-gray-600">{c.type}</td>
                <td className="px-4 py-3 text-gray-600">{c.policies}</td>
                <td className="px-4 py-3"><span className={`px-2 py-0.5 rounded-full text-xs font-medium ${statusColor[c.status] || 'bg-gray-100 text-gray-600'}`}>{c.status}</span></td>
                <td className="px-4 py-3">
                  <button onClick={() => setContacts(p => p.filter(x => x.id !== c.id))} className="text-xs text-red-500 hover:text-red-700">Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 w-full max-w-md shadow-xl">
            <h2 className="text-lg font-semibold mb-4">New Contact</h2>
            <div className="space-y-3">
              {(['name','email','phone'] as const).map(k => (
                <input key={k} placeholder={k.charAt(0).toUpperCase()+k.slice(1)} value={newContact[k]}
                  onChange={e => setNewContact(p => ({ ...p, [k]: e.target.value }))}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
              ))}
              <select value={newContact.type} onChange={e => setNewContact(p => ({ ...p, type: e.target.value }))}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm">
                <option>Prospect</option><option>Client</option>
              </select>
            </div>
            <div className="flex gap-3 mt-4">
              <button onClick={addContact} className="flex-1 px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700">Add Contact</button>
              <button onClick={() => setShowModal(false)} className="flex-1 px-4 py-2 bg-gray-100 text-gray-700 text-sm rounded-lg hover:bg-gray-200">Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default ContactManagement;
